var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 29.793,
    viewBox: "0 0 27 29.793",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "bell",
    d: "M27.758,16.957,25.4,8.472A11.57,11.57,0,0,0,2.96,9.06L1.134,17.271a6.206,6.206,0,0,0,6.058,7.553H8.575a6.206,6.206,0,0,0,12.164,0h1.04a6.206,6.206,0,0,0,5.98-7.867Zm-13.1,10.349a3.724,3.724,0,0,1-3.5-2.482h6.991a3.724,3.724,0,0,1-3.5,2.482Zm10.086-6.436a3.7,3.7,0,0,1-2.965,1.471H7.192A3.724,3.724,0,0,1,3.558,17.81L5.382,9.6a9.087,9.087,0,0,1,17.626-.462l2.358,8.485a3.7,3.7,0,0,1-.623,3.25Z",
    transform: "translate(-0.986 -0.002)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.9baebec598538ca368325fadb9928b42.svg";
export { ForwardRef as ReactComponent };